import { supabaseClient } from "supabase";

export const deleteApplication = async ({ id }: { id: number }) => {
  const { error } = await supabaseClient
    .from("applications")
    .delete()
    .eq("id", id);
  if (error) {
    throw error;
  }
  return null;
};
